import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { loginUser, clearError } from "../../redux/slices/authSlice";
import api from "../../services/api";
import "./login.css";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading, error, token, user } = useSelector((state) => state.auth);

  // Form State
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [localError, setLocalError] = useState("");


  // Redirect on successful login
  useEffect(() => {
    if (token && user) {
      navigate("/product");
    }
  }, [token, user, navigate]);

  // Clear errors on unmount
  useEffect(() => {
    return () => {
      dispatch(clearError());
    };
  }, [dispatch]);

  // Handle Form Submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setLocalError("");
    dispatch(clearError());

    if (!identifier.trim()) {
      setLocalError("Please enter your email or phone number");
      return;
    }
    if (!password) {
      setLocalError("Please enter your password");
      return;
    }

    // Backend currently uses the 'email' field in the payload 
    // to search for the user, so we pass the identifier as 'email'.
    const payload = {
      email: identifier.trim(),
      password: password
    };

    dispatch(loginUser(payload));
  };

  return (
    <div className="auth-layout">
      {/* PROFESSIONAL CENTRALIZED CONTAINER */}
      <div className="auth-main-wrapper fade-in">
        <div className="auth-split-container">

          {/* LEFT SECTION: HIGH-IMPACT BRANDING */}
          <div className="banner-side">
            <img
              src="https://i.ibb.co/yMSbbd1/ssssss.png"
              alt="Book Edu Branding"
              className="banner-image"
            />
          </div>


          {/* RIGHT SECTION: AUTHENTICATION FORM */}
          <div className="form-side">
            <div className="form-content-wrapper">
              <div className="auth-brand-header text-center">
                {/* <img src="/book-edu-logo.png" alt="Book Edu Logo" className="brand-logo-small" /> */}
                <h2>Welcome Back</h2>
                <p>Sign in to your account to continue</p>
              </div>
              {(error || localError) && (
                <div className="auth-alert error-alert">
                  {error || localError}
                </div>
              )}

              <form className="login-form-core" onSubmit={handleSubmit}>
                <div className="form-input-box">
                  <input
                    type="text"
                    id="identifier"
                    className="modern-input"
                    placeholder="Email or Phone Number"
                    value={identifier}
                    onChange={(e) => setIdentifier(e.target.value)}
                    required
                  />
                </div>

                <div className="form-input-box">
                  <input
                    type="password"
                    id="password"
                    className="modern-input"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>

                <div className="form-flex-options">
                  <label className="checkbox-label">
                    <input type="checkbox" id="remember" />
                    <span>Remember me</span>
                  </label>
                  <span className="forgot-link">Forgot Password?</span>
                </div>

                <button
                  type="submit"
                  className="login-submit-btn"
                  disabled={isLoading}
                >
                  {isLoading ? <div className="spinner-small"></div> : "Login"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};


export default Login;

